import { render, staticRenderFns } from "./PayPalCasesMessagesItems.vue?vue&type=template&id=2e132efa&scoped=true"
import script from "./PayPalCasesMessagesItems.vue?vue&type=script&lang=js"
export * from "./PayPalCasesMessagesItems.vue?vue&type=script&lang=js"
import style0 from "./PayPalCasesMessagesItems.vue?vue&type=style&index=0&id=2e132efa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e132efa",
  null
  
)

export default component.exports